<template>
  <component :is="currentMode"></component>
</template>

<script>
import ChatComponent from './components/ChatComponent.vue'
import StorageComponent from './components/StorageComponent.vue'
import SocialComponent from './components/SocialComponent.vue'
import { w } from './utils/helpers'

export default {
  name: 'App',
  components: {
    ChatComponent,
    StorageComponent,
    SocialComponent
  },
  created() {

    if ( w.mode == 'chat' || w.mode == 'popout' )
      this.currentMode = 'ChatComponent'

    if ( w.mode == 'frameStorage' )
      this.currentMode = 'StorageComponent'

    //add social iframe mode

    if ( w.mode == 'social' )
      this.currentMode = 'SocialComponent'

  },
  data() {
    return {
      currentMode: null
    }
  }
}
</script>
